import { useCallback, useEffect, useState } from 'react'
import moment from 'moment/moment'
import useForm from 'tennders-common/form/hooks/useForm'
import { apiGet } from 'tennders-stracture/libs/api'

const useMultipleCostInvoiceForm = ({ selectedTransaction, initialForm }) => {
  const [company, setCompany] = useState(null)
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null)
  const [costInvoices, setCostInvoices] = useState([])
  const { form, onChange, errors, seterrors: setErrors, setform: setForm } = useForm({
    initialForm: initialForm || {
      company: null,
      dateOfReceipt: null,
      paymentTerm: null,
      reversedVat: false,
      irpf: null,
      defaultVat: null,
      id: null,
      invoiceNo: '',
      creditNote: false
    }
  })

  const onCompanyChange = useCallback((company) => {
    // if ( !form.id) {
    // console.info('changing', company)
    const f = { ...form }
    f.company = company?.id
    if (company?.preferences?.irpf) {
      f.irpf = company.preferences?.irpf
      f.defaultVat = company.preferences?.vat || null
    }
    setForm(prev => ({
      ...prev,
      ...f
    }))
    // }
    // onChange('company', company)
    setCompany(company)
  }, [form])

  const fetchCostInvoices = useCallback(async (companyId) => apiGet('/costInvoices/ofCompany/' + companyId), [company?.id])

  useEffect(() => {
    if (company?.id) {
      fetchCostInvoices(company?.id).then((res) => {
        setCostInvoices(res)
      })
    } else {
      setCostInvoices([])
    }
  }, [company])

  useEffect(() => {
    if (selectedTransaction?.matchedTruck?.company) {
      apiGet('/companies/' + selectedTransaction.matchedTruck.company?.id).then(res => onCompanyChange(res))
    } else if (form?.company && !company.id) {
      apiGet('/companies/' + form?.company).then(res => onCompanyChange(res))
    }
  }, [selectedTransaction])

  const calculatesDueDate = useCallback((selectedPaymentTerm, dateOfReceipt) => {
    const paymentTermDays = selectedPaymentTerm?.days
    if (typeof paymentTermDays !== 'undefined' && dateOfReceipt && !form.dueForced) {
      const dueDate = moment(dateOfReceipt).add('days', paymentTermDays)
        .set('hours', 17)

        .toDate()
      setForm(prev => ({
        ...prev,
        dueDate
      }))
      setErrors(prev => ({
        ...prev,
        dueDate: null
      }))
    }
  }, [selectedPaymentTerm, form?.dateOfReceipt, form?.dueForced])

  const onDueDateChange = useCallback((dueDate) => {
    setForm(prev => ({
      ...prev,
      dueForced: !!dueDate,
      dueDate
    }))
  }, [form])

  const onDateOfReceiptChange = useCallback((_, dateOfReceipt) => {
    onChange('dateOfReceipt', dateOfReceipt)
    /* if (selectedPaymentTerm && dateOfReceipt !== form?.dateOfReceipt && !form.dueForced) {
      if (form?.dateOfReceipt) {
        const diff = moment(dateOfReceipt).diff(moment(form?.dateOfReceipt), 'days')
        const dueDate = moment(form?.dueDate).add('days', diff).toDate()
        setForm(prev => ({
          ...prev,
          dateOfReceipt,
          dueDate
        }))
        setErrors(prev => ({
          ...prev,
          dueDate: null
        }))
      } else {
        onChange('dateOfReceipt', dateOfReceipt)
        calculatesDueDate(selectedPaymentTerm, dateOfReceipt)
      }
    } */
  }, [selectedPaymentTerm, form, form?.dueForced])

  return {
    onDateOfReceiptChange,
    calculatesDueDate,
    onCompanyChange,
    onChange,
    form,
    setForm,
    company,
    setCompany,
    onDueDateChange,
    selectedPaymentTerm,
    costInvoices,
    errors,
    setErrors,
    fetchCostInvoices
  }
}

export default useMultipleCostInvoiceForm
